import {Routes, Route, Navigate, BrowserRouter, } from 'react-router-dom';  
import Footer from'./Component/Footer'
import Home from'./Pages/Home'   
import AboutUs from'./Pages/AboutUs'
import VissionMission from'./Pages/VissionMission'
import SchoolUniform from'./Pages/SchoolUniform'
import Fee from'./Pages/Fee'
import Cbse from'./Pages/Cbse'
import ExaminationPromotion from'./Pages/ExaminationPromotion'
import WithdrawalsDismissals from'./Pages/WithdrawalsDismissals'
import Registration from'./Pages/Registration'
import Admission from'./Pages/Admission'
import AdmissionRequirements from'./Pages/AdmissionRequirements'
import VideoGallery from'./Pages/VideoGallery'
import ToppersXII from'./Pages/ToppersXII'
import Toppers from'./Pages/Toppers' 
import News from'./Pages/News'
import PrincipalMessage from'./Pages/PrincipalMessage'
import DirectorMessage from'./Pages/DirectorMessage'
import Gallery from'./Pages/Gallery'
import SubGallery from'./Pages/SubGallery'
import Events from'./Pages/Events' 
 import ErpSoftware from'./Pages/ErpSoftware'
 import ContactUs from'./Pages/ContactUs'
 import Tc from'./Pages/Tc' 
  import Facilities from'./Pages/Facilities'
function App() { 
  return (
      <>
      <BrowserRouter> 
       <Routes> 
             <Route path="/" element={<Home/>} />
             <Route path="/AboutUs" element={<AboutUs/>} />
             <Route path="/VissionMission" element={<VissionMission/>} />
             <Route path="/SchoolUniform" element={<SchoolUniform/>} />
             <Route path="/Fee" element={<Fee/>} />
             <Route path="/ExaminationPromotion" element={<ExaminationPromotion/>} />
             <Route path="/WithdrawalsDismissals" element={<WithdrawalsDismissals/>} />
             <Route path="/AdmissionRequirements" element={<AdmissionRequirements/>} />
             <Route path="/Registration" element={<Registration/>} />
             <Route path="/Admission" element={<Admission/>} />
             <Route path="/VideoGallery" element={<VideoGallery/>} />
             <Route path="/ToppersXII" element={<ToppersXII/>} />
             <Route path="/Toppers" element={<Toppers/>} /> 
             <Route path="/News" element={<News/>} /> 
             <Route path="/PrincipalMessage" element={<PrincipalMessage/>} /> 
              <Route path="/DirectorMessage" element={<DirectorMessage/>} />
               <Route path="/Gallery" element={<Gallery/>} />
               <Route path="/SubGallery" element={<SubGallery/>} />
               <Route path="/Events" element={<Events/>} /> 
                <Route path="/Cbse" element={<Cbse/>} /> 
               <Route path="/ErpSoftware" element={<ErpSoftware/>} /> 
            <Route path="/ContactUs" element={<ContactUs/>} /> 
             <Route path="/Tc" element={<Tc/>} />  
             <Route path="/Facilities" element={<Facilities/>} /> 
       </Routes> 
       <Footer/>
     </BrowserRouter>
      </>
  )
}

export default App;
